var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { client as braintreeClient, venmo, dataCollector, } from "braintree-web";
import { usePayment } from "../../app/usePayment";
import { useNotifications } from "../../app/useNotifications";
import classNames from "classnames";
var TEST_PAYLOAD = {
    nonce: "fake-venmo-account-nonce",
    details: { username: "VenmoJoe" },
    type: "",
};
export var VenmoMask = function (_a) {
    var paymentMethodUsage = _a.paymentMethodUsage, desktopFlow = _a.desktopFlow, mobileWebFallBack = _a.mobileWebFallBack, _b = _a.allowNewBrowserTab, allowNewBrowserTab = _b === void 0 ? true : _b, profile_id = _a.profile_id, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c, buttonText = _a.buttonText, useTestNonce = _a.useTestNonce, setVenmoUserName = _a.setVenmoUserName, ignoreBowserSupport = _a.ignoreBowserSupport, useKount = _a.useKount, lineItems = _a.lineItems, shipping = _a.shipping;
    var _d = usePayment(), handlePurchase = _d.handlePurchase, paymentInfo = _d.paymentInfo, clientToken = _d.clientToken;
    var notify = useNotifications().notify;
    var _e = useState(false), displayButton = _e[0], setDisplayButton = _e[1];
    var _f = useState(false), venmoDisabled = _f[0], setVenmoDisabled = _f[1];
    var _g = useState(), currentVenmoInstance = _g[0], setVenmoInstance = _g[1];
    var _h = useState(""), deviceData = _h[0], setDeviceData = _h[1];
    var venmoForm = React.useRef(null);
    var handleVenmoError = function (err) {
        if (err.code === "VENMO_CANCELED") {
            notify("Error", "App is not available or user aborted payment flow");
        }
        else if (err.code === "VENMO_APP_CANCELED") {
            notify("Error", "User canceled payment flow");
        }
        else {
            notify("Error", err.message);
        }
    };
    var handleVenmoSuccess = function (payload) {
        handlePurchase(payload.nonce, {
            deviceData: deviceData,
            lineItems: lineItems,
            shipping: shipping,
        });
        setVenmoUserName(payload.details.username);
    };
    var clickVenmoButton = function (e) {
        e.preventDefault();
        if (!currentVenmoInstance)
            return;
        setVenmoDisabled(true);
        currentVenmoInstance.tokenize({}, function (tokenizeErr, payload) {
            setVenmoDisabled(false);
            if (useTestNonce) {
                handleVenmoSuccess(TEST_PAYLOAD);
                return;
            }
            else if (tokenizeErr) {
                handleVenmoError(tokenizeErr);
            }
            else if (payload) {
                handleVenmoSuccess(payload);
            }
            else {
                notify("Error", "Couldn't create payment");
            }
        });
    };
    useEffect(function () {
        braintreeClient.create({
            authorization: clientToken,
        }, function (clientErr, clientInstance) {
            if (clientErr) {
                notify("Error", "Error creating client" + clientErr.message);
                return;
            }
            dataCollector.create({
                client: clientInstance,
                paypal: true,
                kount: useKount !== null && useKount !== void 0 ? useKount : undefined,
            }, function (dataCollectorErr, dataCollectorInstance) {
                if (dataCollectorErr || !dataCollectorInstance) {
                    return;
                }
                setDeviceData(dataCollectorInstance.deviceData);
            });
            var venmoFlowOption = desktopFlow === "desktopWebLogin"
                ? { allowDesktopWebLogin: true }
                : { allowDesktop: true };
            if (!allowNewBrowserTab) {
                venmoFlowOption = __assign(__assign({}, venmoFlowOption), { allowNewBrowserTab: false });
            }
            if (profile_id) {
                venmoFlowOption = __assign(__assign({}, venmoFlowOption), { profileId: profile_id });
            }
            venmo.create(__assign({ client: clientInstance, mobileWebFallBack: mobileWebFallBack, paymentMethodUsage: paymentMethodUsage }, venmoFlowOption), function (venmoErr, venmoInstance) {
                if (venmoErr) {
                    notify("Error", "Error creating Venmo:" + venmoErr.message);
                    return;
                }
                if (!venmoInstance.isBrowserSupported()) {
                    if (!ignoreBowserSupport) {
                        notify("Error", "Browser does not support Venmo");
                        return;
                    }
                    notify("Warning", "Browser does not support Venmo - will be ignored due to settings");
                }
                setDisplayButton(true);
                setVenmoInstance(venmoInstance);
                if (!allowNewBrowserTab) {
                    return;
                }
                if (venmoInstance.hasTokenizationResult()) {
                    venmoInstance.tokenize(function (tokenizeErr, payload) {
                        if (useTestNonce) {
                            handleVenmoSuccess(TEST_PAYLOAD);
                            return;
                        }
                        else if (tokenizeErr) {
                            handleVenmoError(tokenizeErr);
                        }
                        else if (payload) {
                            handleVenmoSuccess(payload);
                        }
                        else {
                            notify("Error", "Couldn't create payment");
                        }
                    });
                    return;
                }
            });
        });
    }, [
        paymentInfo,
        clientToken,
        paymentMethodUsage,
        desktopFlow,
        mobileWebFallBack,
    ]);
    return (_jsx("form", __assign({ onSubmit: clickVenmoButton, ref: venmoForm }, { children: _jsx("button", __assign({ disabled: venmoDisabled, type: "submit", className: classNames({
                "justify-center align-center rounded-md px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 text-white bg-blue-500 hover:bg-blue-600  shadow-sm": true,
                "w-full": fullWidth,
                hidden: !displayButton,
            }), id: "submit" }, { children: buttonText })) })));
};
